import { Countries as JSCountries } from './CountryCodesJS'

export interface ICountryInfo {
  name: string
  native: string
  phone: string
  continent: string
  capital: string
  currency: string
  languages: string[]
  emoji: string
  emojiU: string
}

export const Countries = JSCountries as Record<string, ICountryInfo>
